import http from '../http'

export const getPlatRoleTree = data => {
  return http.request({
    url: 'plat/queryPlatRoleTree',
    data,
    method: 'get'
  })
}

export const updatePlatRole = data => {
  return http.request({
    url: 'plat/updateRole',
    data,
    method: 'post'
  })
}

export const addRole = data => {
  return http.request({
    url: 'plat/addRole',
    data,
    method: 'post'
  })
}

export const getPlatMenuTree = data => {
  return http.request({
    url: 'plat/queryPlatMenuTree',
    data,
    method: 'get'
  })
}

export const queryRoleMenuTree = data => {
  return http.request({
    url: 'plat/queryRoleMenuTree',
    data,
    method: 'get'
  })
}

export const updateRoleMenu = data => {
  return http.request({
    url: 'plat/updateRoleMenu',
    data,
    method: 'post'
  })
}

export const addMenu = data => {
  return http.request({
    url: 'plat/addMenu',
    data,
    method: 'post'
  })
}

export const updateMenu = data => {
  return http.request({
    url: 'plat/updateMenu',
    data,
    method: 'post'
  })
}

export const deleteMenu = data => {
  return http.request({
    url: 'plat/deleteMenu',
    data,
    method: 'get'
  })
}

export const updatePlat = data => {
  return http.request({
    url: 'plat/updatePlat',
    data,
    method: 'post'
  })
}

export const addPlat = data => {
  return http.request({
    url: 'plat/addPlat',
    data,
    method: 'post'
  })
}
